import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import ToggleButton from "widgets/shared/toggle/components/ToggleButton";
import { ToggleLayout } from "widgets/shared/toggle/components/ToggleLayout";
import SelfInstallmentWarning from "./components/self-installment-warning";
import classNames from "classnames";
import { resetSelfAssemblyInputs } from "shared/store/selfAssembly/selfAssemblyInputs";
import { useScreenSize } from "app/hooks/shared/useScreenSize";

const InstallmentOptionControls = ({
  setSelfAssemblyPageOpen,
}: {
  setSelfAssemblyPageOpen?: (open: boolean) => void;
}) => {
  const { updateSelfAssembleData, selfAssembleDoorData, selectedDoor } =
    useConfigurationOptionsContext();

  const { isMobileScreen } = useScreenSize();
  const setIsAssembly = (selfAssembly: boolean) => {
    updateSelfAssembleData({
      ...selfAssembleDoorData,
      selfAssembly: selfAssembly,
    });
  };

  const toggleGewoonMontage = () => {
    setIsAssembly(false);
    if (isMobileScreen) {
      setSelfAssemblyPageOpen?.(false);
    }
    resetSelfAssemblyInputs();
  };

  const toggleSelfAssembly = () => {
    setIsAssembly(true);
    if (isMobileScreen) {
      setSelfAssemblyPageOpen?.(true);

      const container = document.getElementById("layout-selector");
      container?.scrollTo({ top: 0, behavior: "smooth" });
    }
    resetSelfAssemblyInputs();
  };

  const isGewoonMontageActive = !selfAssembleDoorData.selfAssembly;

  if (!selectedDoor) return null;

  const selfAssemblyDiscount = selectedDoor.selfAssemblyDiscount;
  return (
    <>
      <ToggleLayout>
        <ToggleButton
          isActive={isGewoonMontageActive}
          onClick={toggleGewoonMontage}
          roundedClass="gg-rounded-l-sm gg-border-l"
          layoutId="mainMontageToggle"
          dataTestId="toggleGewoonMontage"
        >
          Montage door GewoonGers
        </ToggleButton>

        <ToggleButton
          isActive={!isGewoonMontageActive}
          onClick={toggleSelfAssembly}
          roundedClass="gg-rounded-r-sm gg-border-r"
          layoutId="mainMontageToggle"
          dataTestId="toggleSelfAssembly"
        >
          Zelf monteren{" "}
          <span
            className={classNames("gg-pl-1 gg-text-xs", {
              "gg-text-white": !isGewoonMontageActive,
              "gg-text-dark-blue/80": isGewoonMontageActive,
            })}
          >
            (-€{selfAssemblyDiscount})
          </span>
        </ToggleButton>
      </ToggleLayout>

      {selfAssembleDoorData.selfAssembly && (
        <div className="gg-hidden gg-pt-3 sm:gg-block">
          <SelfInstallmentWarning selectedDoor={selectedDoor.code} />
        </div>
      )}
    </>
  );
};
export default InstallmentOptionControls;
